import React from "react";
import AddressesPageGen from "./generated/AddressesPageGen";
import addressesService from "../../../services/legacy/addressesService";

const SHOW_IN_GRID = new Set(["name", "phone", "country", "zipcode", "state", "county", "city"]);
const SHOW_IN_FILTER = new Set(["name", "phone", "country", "zipcode", "state", "county", "city"]);

const transformColumns = (baseColumns) => {
  return baseColumns.map((column) => ({
    ...column,
    showInGrid: SHOW_IN_GRID.has(column.key),
    showInFilter: SHOW_IN_FILTER.has(column.key),
  }));
};

const AddressesPage = () => {
  const service = addressesService;
  return <AddressesPageGen service={service} transformColumns={transformColumns} />;
};

export default AddressesPage;